import GroupProductCountdown from './components/GroupProductCountdown';
import ProductActivity from './components/ProductActivity';
import ProductCoupon from './components/ProductCoupon';
import ProductDataSheet from './components/ProductDataSheet';
import ProductDescription from './components/ProductDescription';
import ProductHeader from './components/ProductHeader';
import ProductIntroduction from './components/ProductIntroduction';
import ProductParams from './components/ProductParams';
import ProductPrice from './components/ProductPrice';
import ProductTop from './components/ProductTop';

export default function DetailPage({ webData, description }) {
  return (
    <>
      <ProductHeader data={webData} />
      <div className="p-[10px]">
        <ProductTop data={webData} />
        <GroupProductCountdown data={webData} />
        <ProductDataSheet data={webData} />
        <ProductPrice data={webData} />
        <ProductCoupon data={webData} />
        <ProductActivity data={webData} />
        <ProductParams data={webData} />
        <ProductIntroduction data={webData} />
        <ProductDescription description={description} />
      </div>
    </>
  );
}
